// import React, { useState, useRef, useEffect, useMemo } from "react";
// import { useNavigate } from "react-router-dom";
// import { useAuth } from "../../Common/Configurations/AuthContext";
// import Header from "../../Common/Layout/Header";
// import config from "../../Common/Configurations/APIConfig";
// import apiService from "../../Common/Configurations/APIService";

// import { 
//     RiMapPinLine, RiCalendarLine, RiUserLine, 
//     RiAddLine, RiDeleteBinLine, RiMagicLine, 
//     RiFlightTakeoffLine, RiSubtractLine, RiCloseLine, RiHotelBedLine,
//     RiCheckLine, RiPlaneLine, RiRestaurantLine, RiArmchairLine
// } from "react-icons/ri";
// import airports from "../../Data/AirportList.json";
// import hotelCities from "../../Data/HotelCities.json"; 
// import InteractiveCitySelector from "./InteractiveCitySelector";
// import "./HolidayFlightPackage.css";

// // --- UTILITY FUNCTIONS ---
// const getCleanCityName = (airport) => airport?.cityName ? airport.cityName.split(',')[0] : '';

// const addDays = (dateStr, days) => {
//     if(!dateStr) return '';
//     const result = new Date(dateStr);
//     result.setDate(result.getDate() + parseInt(days));
//     return result.toISOString().split('T')[0];
// };

// const formatDate = (dateInput, format = 'full') => {
//     if(!dateInput) return '';
//     const d = new Date(dateInput);
//     if (isNaN(d.getTime())) return '';

//     const day = String(d.getDate()).padStart(2, '0');
//     const month = String(d.getMonth() + 1).padStart(2, '0');
//     const year = d.getFullYear();
//     const shortYear = String(year).slice(-2);
//     const monthShort = d.toLocaleDateString('en-GB', { month: 'short' });

//     switch(format) {
//         case 'numeric': return `${day}-${month}-${shortYear}`;
//         case 'short': return `${d.getDate()} ${monthShort}`;
//         case 'full': 
//         default: return `${day}-${month}-${year}`;
//     }
// };

// const defaultStartDate = new Date(Date.now() + 86400000).toISOString().split('T')[0];

// const HolidayFlightPackage = () => {
//     const { user, loading } = useAuth();
//     const navigate = useNavigate();
//     const passengerRef = useRef(null);

//     // --- STATE ---
//     const [origin, setOrigin] = useState({ airport: null, query: '', date: defaultStartDate });
//     const [returnDest, setReturnDest] = useState({ airport: null, query: '' });
    
//     const [destinations, setDestinations] = useState([
//         { id: Date.now(), airport: null, query: '', nights: 3, selectedCities: [] }
//     ]);

//     const [formData, setFormData] = useState({
//         adults: 2, children: 0, infants: 0, 
//         numRooms: 1, 
//         hotelCategory: '5',
//         mealType: 'MAP', 
//         cabinClass: 'ECONOMY',
//     });

//     const [activeSearch, setActiveSearch] = useState(null); 
//     const [searchResults, setSearchResults] = useState([]);
//     const [isPassengerDropdownOpen, setPassengerDropdownOpen] = useState(false);
//     const [showAdvancedOptions, setShowAdvancedOptions] = useState(false);
    
//     const [showSummaryModal, setShowSummaryModal] = useState(false);
//     const [isGenerating, setIsGenerating] = useState(false);
//     const [activeModalDestIndex, setActiveModalDestIndex] = useState(null); 

//     useEffect(() => { if (!loading && !user) navigate("/"); }, [user, loading, navigate]);
    
//     // --- DERIVED STATE ---
//     const totalNights = useMemo(() => {
//         return destinations.reduce((acc, dest) => acc + dest.nights, 0);
//     }, [destinations]);

//     const returnDate = useMemo(() => {
//         return addDays(origin.date, totalNights);
//     }, [origin.date, totalNights]);

//     // --- HANDLERS ---
//     const handleSearch = (value, type, index = null) => {
//         if (type === 'origin') setOrigin(prev => ({ ...prev, query: value, airport: value === '' ? null : prev.airport }));
//         else if (type === 'return') setReturnDest(prev => ({ ...prev, query: value, airport: value === '' ? null : prev.airport }));
//         else {
//             const newDest = [...destinations];
//             newDest[index].query = value;
//             if (value === '') { 
//                 newDest[index].airport = null; 
//                 newDest[index].selectedCities = []; 
//             }
//             setDestinations(newDest);
//         }

//         if (value.length > 1) {
//             const lowerValue = value.toLowerCase();
//             const filtered = airports.filter(airport =>
//                 airport.cityName.toLowerCase().includes(lowerValue) || 
//                 airport.airportCode.toLowerCase().includes(lowerValue)
//             ).slice(0, 7);
//             setSearchResults(filtered);
//             setActiveSearch(type === 'origin' ? 'origin' : type === 'return' ? 'return' : index);
//         } else {
//             setSearchResults([]);
//             setActiveSearch(null);
//         }
//     };

//     const handleSelect = (airport, type, index = null) => {
//         const cleanName = `${getCleanCityName(airport)} (${airport.airportCode})`;
//         const cityNameOnly = getCleanCityName(airport);
        
//         if (type === 'origin') {
//             setOrigin(prev => ({ ...prev, airport: airport, query: cleanName }));
//             if (!returnDest.airport) setReturnDest({ airport: airport, query: cleanName });
//         } else if (type === 'return') {
//             setReturnDest({ airport: airport, query: cleanName });
//         } else {
//             const newDest = [...destinations];
//             const prevCountry = newDest[index].airport?.countryName;
            
//             newDest[index].airport = airport;
//             newDest[index].query = cleanName;
            
//             if (prevCountry !== airport.countryName) {
//                 newDest[index].selectedCities = [];
//             }
            
//             const cityExists = newDest[index].selectedCities.some(c => c.name === cityNameOnly);
//             if (!cityExists) {
//                 newDest[index].selectedCities.push({ 
//                     name: cityNameOnly, 
//                     nights: newDest[index].nights, 
//                     country: airport.countryName 
//                 });
//             }
//             setDestinations(newDest);
//         }
//         setSearchResults([]);
//         setActiveSearch(null);
//     };

//     // --- DURATION HANDLERS ---
//     const handleTotalDurationChange = (delta) => {
//         const newDest = [...destinations];
//         const currentFirstNights = newDest[0].nights;
        
//         if (currentFirstNights + delta >= 1) {
//             newDest[0].nights += delta;
//             if (newDest[0].selectedCities.length === 1) {
//                 newDest[0].selectedCities[0].nights += delta;
//             }
//             setDestinations(newDest);
//         }
//     };

//     const handleDestNightsChange = (index, delta) => {
//         const newDest = [...destinations];
//         const newVal = Math.max(1, newDest[index].nights + delta);
//         newDest[index].nights = newVal;
//         if (newDest[index].selectedCities.length === 1) {
//             newDest[index].selectedCities[0].nights = newVal;
//         }
//         setDestinations(newDest);
//     };

//     const addDestinationBlock = () => {
//         setDestinations([...destinations, { id: Date.now(), airport: null, query: '', nights: 3, selectedCities: [] }]);
//     };

//     const removeDestinationBlock = (index) => {
//         if (destinations.length > 1) {
//             setDestinations(destinations.filter((_, i) => i !== index));
//         }
//     };

//     // --- CITY MANAGEMENT ---
//     const handleAddCity = (destIndex, cityName) => {
//         const newDest = [...destinations];
//         if (!newDest[destIndex].selectedCities.some(c => c.name === cityName)) {
//             newDest[destIndex].selectedCities.push({ name: cityName, nights: 1, country: newDest[destIndex].airport.countryName });
//             setDestinations(newDest);
//         }
//     };

//     const handleRemoveCity = (destIndex, cityName) => {
//         const newDest = [...destinations];
//         newDest[destIndex].selectedCities = newDest[destIndex].selectedCities.filter(c => c.name !== cityName);
//         setDestinations(newDest);
//     };

//     const handleCityNightsChange = (destIndex, cityName, delta) => {
//         const newDest = [...destinations];
//         const cityIdx = newDest[destIndex].selectedCities.findIndex(c => c.name === cityName);
//         if (cityIdx > -1) {
//             const newNights = newDest[destIndex].selectedCities[cityIdx].nights + delta;
//             if (newNights > 0) {
//                 newDest[destIndex].selectedCities[cityIdx].nights = newNights;
//                 setDestinations(newDest);
//             }
//         }
//     };

//     const handleCityReorder = (destIndex, newCityOrder) => {
//         const newDest = [...destinations];
//         newDest[destIndex].selectedCities = newCityOrder;
//         setDestinations(newDest);
//     };

//     const handlePassengerChange = (type, delta) => {
//         setFormData(prev => {
//             const val = prev[type] + delta;
//             if (val < 0 || (type === 'adults' && val < 1)) return prev;
//             return { ...prev, [type]: val };
//         });
//     };

//     // --- GENERATE ---
//     const handleReviewClick = () => {
//         if(!origin.airport) { alert("Please select a valid 'Fly From' origin city."); return; }
//         const invalidDest = destinations.find(d => !d.airport);
//         if(invalidDest) { alert("Please select a city for all Destination blocks."); return; }
//         setShowSummaryModal(true);
//     };

//     // === API INTEGRATION HERE ===
//     const handleConfirmGenerate = async () => {
//         setIsGenerating(true);
//         const flights = [];
//         let currentDate = origin.date;
//         let previousAirport = origin.airport;
//         let hotels = [];

//         destinations.forEach(dest => {
//             // 1. Build Flight Object
//             flights.push({ 
//                 departure: previousAirport.airportCode, 
//                 arrival: dest.airport.airportCode, 
//                 departureDate: currentDate 
//             });

//             let cityRunningDate = currentDate;

//             // 2. Build Hotel Objects
//             dest.selectedCities.forEach(city => {
//                 const searchCity = city.name.trim().toLowerCase();
//                 const searchCountry = dest.airport.countryName.trim().toLowerCase();

//                 const matchedHotelCity = hotelCities.find(h => 
//                     h.cityName.toLowerCase() === searchCity && 
//                     h.countryName.toLowerCase() === searchCountry
//                 );

//                 const finalCityCode = matchedHotelCity ? String(matchedHotelCity.id) : city.name.substring(0, 3).toUpperCase();
//                 const finalCountryCode = dest.airport.countryCode || 'XX';

//                 hotels.push({
//                     name: city.name, 
//                     nights: city.nights, 
//                     country: city.country, 
//                     checkInDate: cityRunningDate,
//                     cityCode: finalCityCode,
//                     countryCode: finalCountryCode 
//                 });
                
//                 cityRunningDate = addDays(cityRunningDate, city.nights);
//             });

//             currentDate = addDays(currentDate, dest.nights);
//             previousAirport = dest.airport;
//         });

//         // 3. Final Return Flight
//         flights.push({ 
//             departure: previousAirport.airportCode, 
//             arrival: returnDest.airport?.airportCode || origin.airport.airportCode, 
//             departureDate: currentDate 
//         });

//         // 4. Generate Key
//         const originCode = origin.airport?.airportCode || 'ORG';
//         const destCodes = destinations.map(d => d.airport?.airportCode || 'DST').join('-');
//         const cleanStartDate = origin.date.replace(/-/g, '');
//         const cleanEndDate = returnDate.replace(/-/g, '');
//         const holidayKey = `${originCode}-${destCodes}-${cleanStartDate}-${cleanEndDate}-${totalNights}N`.toUpperCase();

//         const payload = {
//             holidayKey: holidayKey, 
//             holidayType: "Flight", 
//             journeyType: destinations.length > 1 ? "MultiCity" : "RoundTrip",
//             flights, 
//             hotels, 
//             numberOfPeople: formData.adults + formData.children + formData.infants,
//             numberOfNights: totalNights, 
//             hotelCategory: formData.hotelCategory, 
//             ...formData, 
//             userId: user?.id,
//             createdBy: user?.companyType
//         };

//         try {
//             console.log("Sending Payload:", payload);
            
//             // --- API CALL ---
//             const response = await apiService.create(config.CREATEHOLIDAY, payload);
//             console.log("API Response:", response);
            
//             setShowSummaryModal(false);

//             // --- NAVIGATION UPDATE ---
//             // Extract the new Holiday ID from the response
//             // Checking multiple common paths (response.holidayId or response.data.holidayId)
//             const newHolidayId = response.holidayId || response.data?.holidayId || response.data?.data?.holidayId;

//             if (newHolidayId) {
//                 navigate(`/holiday/${newHolidayId}`, { state: { activeTab: 9 } }); 
//             } else {
//                 // Fallback if ID cannot be found
//                 console.warn("Holiday created but ID not returned in response structure.");
//                 navigate("/dashboard");
//             }

//         } catch (error) {
//             console.error("Error generating holiday:", error);
//         } finally {
//             setIsGenerating(false);
//         }
//     };

//     let timelineDate = origin.date;
//     let cardRunningDate = origin.date;

//     return (
//         <div id="layout-wrapper">
//             <Header User={user} />
//             <div className="main-content" style={{ marginTop: '5px' }}>
//                 <div className="page-content">
//                     <div className="container-fluid">
//                         <div style={{ maxWidth: '1200px', margin: '0 auto' }}>

//                             <div className="hfp-wrapper">
//                                 {/* 1. TOP BAR */}
//                                 <div className="hfp-top-bar origin-theme">
//                                     <div className="hfp-input-group hfp-col-origin hfp-search-container">
//                                         <label className="hfp-label-mini text-indigo"><RiFlightTakeoffLine/> Fly From</label>
//                                         <input 
//                                             type="text" className="hfp-input-compact border-indigo" placeholder="Hyderabad (HYD)"
//                                             value={origin.query}
//                                             onChange={(e) => handleSearch(e.target.value, 'origin')}
//                                         />
//                                         {activeSearch === 'origin' && searchResults.length > 0 && (
//                                             <div className="hfp-dropdown-results">
//                                                 {searchResults.map(apt => (
//                                                     <div key={apt.airportCode} className="hfp-result-item" onClick={() => handleSelect(apt, 'origin')}>
//                                                         <strong>{getCleanCityName(apt)} ({apt.airportCode})</strong>
//                                                     </div>
//                                                 ))}
//                                             </div>
//                                         )}
//                                     </div>

//                                     <div className="hfp-input-group" style={{width: '180px'}}>
//                                         <label className="hfp-label-mini"><RiCalendarLine/> Start Date</label>
//                                         <input 
//                                             type="date" className="hfp-input-compact"
//                                             value={origin.date}
//                                             onChange={(e) => setOrigin({...origin, date: e.target.value})}
//                                             min={defaultStartDate}
//                                         />
//                                     </div>

//                                     <div className="hfp-input-group text-center" style={{width: '130px'}}>
//                                         <label className="hfp-label-mini">Total Duration</label>
//                                         <div className="hfp-counter-compact">
//                                             <button onClick={() => handleTotalDurationChange(-1)}><RiSubtractLine /></button>
//                                             <span style={{ minWidth: '35px', textAlign: 'center' }}>{totalNights} N</span>
//                                             <button onClick={() => handleTotalDurationChange(1)}><RiAddLine /></button>
//                                         </div>
//                                     </div>

//                                     <div className="hfp-input-group" style={{position: 'relative', width: '250px'}} ref={passengerRef}>
//                                         <label className="hfp-label-mini"><RiUserLine/> Travelers</label>
//                                         <button className="hfp-input-compact text-start" onClick={() => setPassengerDropdownOpen(!isPassengerDropdownOpen)}>
//                                             {formData.adults} Adult, {formData.children} Kids, {formData.infants} Inf
//                                         </button>
//                                         {isPassengerDropdownOpen && (
//                                             <div className="hfp-passenger-dropdown">
//                                                 {['Adults', 'Children', 'Infants'].map(type => (
//                                                     <div key={type} className="hfp-p-row">
//                                                         <span className="hfp-p-label">{type}</span>
//                                                         <div className="hfp-p-ctrl">
//                                                             <button onClick={() => handlePassengerChange(`${type.toLowerCase()}`, -1)}><RiSubtractLine/></button>
//                                                             <span>{formData[`${type.toLowerCase()}`]}</span>
//                                                             <button onClick={() => handlePassengerChange(`${type.toLowerCase()}`, 1)}><RiAddLine/></button>
//                                                         </div>
//                                                     </div>
//                                                 ))}
//                                             </div>
//                                         )}
//                                     </div>

//                                     <div className="hfp-input-group" style={{width: '150px'}}>
//                                         <label className="hfp-label-mini"><RiCalendarLine/> Return Date</label>
//                                         <input 
//                                             type="text" className="hfp-input-compact" 
//                                             value={formatDate(returnDate, 'full')} 
//                                             readOnly 
//                                             style={{backgroundColor: '#f9fafb', cursor: 'default', color: '#666'}}
//                                         />
//                                     </div>
//                                 </div>

//                                 {/* 2. DESTINATIONS */}
//                                 <div className="hfp-middle-section">
//                                     <div className="hfp-scroll-container">
//                                         {destinations.map((dest, index) => {
//                                             const currentBlockStartDate = cardRunningDate;
//                                             cardRunningDate = addDays(cardRunningDate, dest.nights);
//                                             let cityRunner = currentBlockStartDate;

//                                             return (
//                                                 <div key={dest.id} className="hfp-dest-card">
//                                                     <div className="hfp-dest-header-colored">
//                                                         <span className="hfp-dh-title">
//                                                             <RiMapPinLine className="me-1"/> 
//                                                             {dest.airport ? dest.airport.countryName : `Destination ${index + 1}`}
//                                                         </span>
//                                                         <button className="hfp-dh-delete" onClick={() => removeDestinationBlock(index)} disabled={destinations.length===1}>
//                                                             <RiDeleteBinLine/>
//                                                         </button>
//                                                     </div>
                                                    
//                                                     <div className="hfp-dest-body">
//                                                         <div className="d-flex gap-2 align-items-end mb-2">
//                                                             <div className="flex-grow hfp-search-container">
//                                                                 <label className="hfp-label-mini">Select City</label>
//                                                                 <input 
//                                                                     type="text" className="hfp-input-compact" placeholder="Search Destination..."
//                                                                     value={dest.query}
//                                                                     onChange={(e) => handleSearch(e.target.value, 'dest', index)}
//                                                                 />
//                                                                 {activeSearch === index && searchResults.length > 0 && (
//                                                                     <div className="hfp-dropdown-results">
//                                                                         {searchResults.map(apt => (
//                                                                             <div key={apt.airportCode} className="hfp-result-item" onClick={() => handleSelect(apt, 'dest', index)}>
//                                                                                 <strong>{getCleanCityName(apt)} ({apt.airportCode})</strong>
//                                                                             </div>
//                                                                         ))}
//                                                                     </div>
//                                                                 )}
//                                                             </div>
//                                                             <div style={{width: '80px'}}>
//                                                                 <label className="hfp-label-mini">Nights</label>
//                                                                 <div className="hfp-counter-compact">
//                                                                     <button onClick={() => handleDestNightsChange(index, -1)}>-</button>
//                                                                     <span>{dest.nights}</span>
//                                                                     <button onClick={() => handleDestNightsChange(index, 1)}>+</button>
//                                                                 </div>
//                                                             </div>
//                                                         </div>

//                                                         {dest.airport && (
//                                                             <div className="hfp-card-places">
//                                                                 <div className="d-flex justify-content-between align-items-center mb-2">
//                                                                     <span className="small fw-bold text-indigo">Stays</span>
//                                                                     <button className="hfp-btn-text" onClick={() => setActiveModalDestIndex(index)}>
//                                                                         <RiAddLine/> Add/Edit Places
//                                                                     </button>
//                                                                 </div>
//                                                                 <div className="hfp-places-list">
//                                                                     {dest.selectedCities.map((city, cIdx) => {
//                                                                         const displayDate = cityRunner;
//                                                                         cityRunner = addDays(cityRunner, city.nights);
//                                                                         return (
//                                                                             <div key={cIdx} className="hfp-place-chip">
//                                                                                 <span className="chip-name">{city.name}</span>
//                                                                                 <div style={{display:'flex', alignItems:'center', gap:'8px'}}>
//                                                                                     <span className="chip-badge"><RiHotelBedLine/> {city.nights}N Hotel Stay</span>
//                                                                                     <span style={{color:'#cbd5e1'}}>|</span>
//                                                                                     <span className="chip-date text-indigo fw-bold">{formatDate(displayDate, 'short')}</span>
//                                                                                 </div>
//                                                                             </div>
//                                                                         );
//                                                                     })}
//                                                                     {dest.selectedCities.length === 0 && <div className="text-center text-muted small fst-italic py-2">No places added</div>}
//                                                                 </div>
//                                                             </div>
//                                                         )}
//                                                         {!dest.airport && <div className="hfp-empty-placeholder">Select a destination above</div>}
//                                                     </div>
//                                                 </div>
//                                             );
//                                         })}
//                                         <button className="hfp-add-dest-card" onClick={addDestinationBlock}>
//                                             <div className="icon-circle"><RiAddLine /></div>
//                                             <span>Add Destination</span>
//                                         </button>
//                                     </div>
//                                 </div>

//                                 {/* Footer */}
//                                 <div className="hfp-footer-compact">
//                                     <button className="hfp-toggle-advanced" onClick={() => setShowAdvancedOptions(!showAdvancedOptions)}>
//                                         {showAdvancedOptions ? 'Hide Advanced Options' : 'Show Advanced Options'}
//                                     </button>
//                                     <button className="hfp-btn-generate" onClick={handleReviewClick}>
//                                         <RiMagicLine className="me-2" /> Review & Generate
//                                     </button>
//                                 </div>
                                
//                                 {showAdvancedOptions && (
//                                     <div className="hfp-advanced-panel">
//                                          <div className="d-flex gap-3">
//                                             <div className="flex-grow">
//                                                 <label className="hfp-label-mini">Class</label>
//                                                 <select className="hfp-input-compact" value={formData.cabinClass} onChange={(e)=>setFormData({...formData, cabinClass: e.target.value})}>
//                                                     <option value="ECONOMY">Economy</option>
//                                                     <option value="BUSINESS">Business</option>
//                                                 </select>
//                                             </div>
//                                             <div className="flex-grow">
//                                                 <label className="hfp-label-mini">Hotel Category</label>
//                                                 <select className="hfp-input-compact" value={formData.hotelCategory} onChange={(e)=>setFormData({...formData, hotelCategory: e.target.value})}>
//                                                     <option value="3">3 Star</option>
//                                                     <option value="4">4 Star</option>
//                                                     <option value="5">5 Star</option>
//                                                 </select>
//                                             </div>
//                                             <div className="flex-grow">
//                                                 <label className="hfp-label-mini">Meal</label>
//                                                 <select className="hfp-input-compact" value={formData.mealType} onChange={(e)=>setFormData({...formData, mealType: e.target.value})}>
//                                                     <option value="CP">Breakfast</option>
//                                                     <option value="MAP">Breakfast & Dinner</option>
//                                                 </select>
//                                             </div>
//                                             <div className="flex-grow">
//                                                 <label className="hfp-label-mini">Rooms</label>
//                                                 <input type="number" className="hfp-input-compact" value={formData.numRooms} onChange={(e)=>setFormData({...formData, numRooms: parseInt(e.target.value) || 1})} min="1"/>
//                                             </div>
//                                          </div>
//                                     </div>
//                                 )}
//                             </div>
//                         </div>

//                         {/* Modals */}
//                         {activeModalDestIndex !== null && (
//                             <div className="hfp-modal-overlay">
//                                 <div className="hfp-modal-container">
//                                     <div className="hfp-modal-header">
//                                         <h3 className="hfp-modal-title">Select Places in {destinations[activeModalDestIndex].airport.countryName}</h3>
//                                         <button className="hfp-modal-close" onClick={() => setActiveModalDestIndex(null)}><RiCloseLine/></button>
//                                     </div>
//                                     <div className="hfp-modal-body">
//                                         <InteractiveCitySelector 
//                                             country={destinations[activeModalDestIndex].airport.countryName}
//                                             cities={destinations[activeModalDestIndex].selectedCities}
//                                             maxNights={destinations[activeModalDestIndex].nights} 
//                                             startDate={defaultStartDate} 
//                                             onAddCity={(name) => handleAddCity(activeModalDestIndex, name)}
//                                             onRemoveCity={(name) => handleRemoveCity(activeModalDestIndex, name)}
//                                             onNightsChange={(name, delta) => handleCityNightsChange(activeModalDestIndex, name, delta)}
//                                             onReorder={(newOrder) => handleCityReorder(activeModalDestIndex, newOrder)}
//                                         />
//                                     </div>
//                                     <div className="hfp-modal-footer"><button className="hfp-btn-primary" onClick={() => setActiveModalDestIndex(null)}>Done</button></div>
//                                 </div>
//                             </div>
//                         )}

//                         {showSummaryModal && (
//                             <div className="hfp-modal-overlay">
//                                 <div className="hfp-modal-container" style={{maxWidth: '800px', borderRadius: '16px'}}>
//                                     <div className="hfp-modal-header border-0 pb-0">
//                                         <h3 className="hfp-modal-title"><RiCheckLine className="text-primary me-2"/> Review Your Itinerary</h3>
//                                         <button className="hfp-modal-close" onClick={() => setShowSummaryModal(false)}><RiCloseLine/></button>
//                                     </div>
//                                     <div className="hfp-modal-body pt-2" style={{background: '#fff'}}>
//                                         <div className="hfp-section-title">TRAVELERS & PREFERENCES</div>
//                                         <div className="hfp-pref-grid">
//                                             <div className="hfp-pref-card"><div className="lbl"><RiUserLine/> Travelers</div><div className="val">{formData.adults} Adults, {formData.children} Kids</div></div>
//                                             <div className="hfp-pref-card"><div className="lbl"><RiHotelBedLine/> Hotel</div><div className="val">{formData.hotelCategory} Star | {formData.numRooms} Room(s)</div></div>
//                                             <div className="hfp-pref-card"><div className="lbl"><RiRestaurantLine/> Meal Plan</div><div className="val">{formData.mealType}</div></div>
//                                             <div className="hfp-pref-card"><div className="lbl"><RiArmchairLine/> Cabin</div><div className="val">{formData.cabinClass}</div></div>
//                                         </div>
//                                         <div className="hfp-section-title mt-4">FLIGHT & STAY TIMELINE</div>
//                                         <div className="hfp-timeline-container">
//                                             {destinations.map((dest, i) => {
//                                                 const flightDate = timelineDate;
//                                                 const fromCode = i === 0 ? origin.airport?.airportCode || 'ORG' : destinations[i-1].airport?.airportCode || 'PRV';
//                                                 const toCode = dest.airport?.airportCode || 'DST';
//                                                 let stayTimeline = timelineDate; 
//                                                 timelineDate = addDays(timelineDate, dest.nights);
//                                                 return (
//                                                     <div key={i} className="hfp-timeline-card">
//                                                         <div className="hfp-timeline-header">
//                                                             <div className="route"><span className="code">{fromCode}</span><RiPlaneLine className="icon-plane" /><span className="code">{toCode}</span></div>
//                                                             <div className="date-badge"><RiCalendarLine/> {formatDate(flightDate, 'full')}</div>
//                                                         </div>
//                                                         <div className="hfp-timeline-stays">
//                                                             {dest.selectedCities.length > 0 ? (
//                                                                 dest.selectedCities.map((city, cIdx) => {
//                                                                     const checkInDate = stayTimeline;
//                                                                     const checkOutDate = addDays(stayTimeline, city.nights);
//                                                                     stayTimeline = checkOutDate;
//                                                                     return (
//                                                                         <div key={cIdx} className="hfp-stay-chip">
//                                                                             <RiHotelBedLine className="icon" />
//                                                                             <span className="city">{city.name} ({city.nights}N)</span>
//                                                                             <span className="date">{formatDate(checkInDate, 'numeric')} to {formatDate(checkOutDate, 'numeric')}</span>
//                                                                         </div>
//                                                                     );
//                                                                 })
//                                                             ) : (<span className="text-muted small">No specific stays added</span>)}
//                                                         </div>
//                                                     </div>
//                                                 );
//                                             })}
//                                             <div className="hfp-timeline-card return">
//                                                 <div className="hfp-timeline-header">
//                                                     <div className="route"><span className="code">{destinations[destinations.length-1].airport?.airportCode || 'LST'}</span><RiPlaneLine className="icon-plane" /><span className="code">{returnDest.airport?.airportCode || origin.airport?.airportCode || 'ORG'}</span></div>
//                                                     <div className="date-badge"><RiCalendarLine/> Return Flight • {formatDate(returnDate, 'full')}</div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                     <div className="hfp-modal-footer pt-3 pb-3" style={{justifyContent: 'flex-end', gap: '10px'}}>
//                                         <button className="hfp-btn-outline" onClick={() => setShowSummaryModal(false)}>Edit</button>
//                                         <button className="hfp-btn-generate" onClick={handleConfirmGenerate} disabled={isGenerating}>
//                                             {isGenerating ? (
//                                                 <>
//                                                     <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
//                                                     Generating...
//                                                 </>
//                                             ) : 'Confirm & Generate'}
//                                         </button>
//                                     </div>
//                                 </div>
//                             </div>
//                         )}
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default HolidayFlightPackage;


import React, { useState, useRef, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../Common/Configurations/AuthContext";
import Header from "../../Common/Layout/Header";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";

import { 
    RiMapPinLine, RiCalendarLine, RiUserLine, 
    RiAddLine, RiDeleteBinLine, RiMagicLine, 
    RiFlightTakeoffLine, RiSubtractLine, RiCloseLine, RiHotelBedLine,
    RiCheckLine, RiPlaneLine, RiRestaurantLine, RiArmchairLine
} from "react-icons/ri";

// Updated Data Imports
import airports from "../../Data/AirportList.json";
import hotelCities from "../../Data/HotelCities.json"; 
import destinationData from "../../Data/DestinationPlaces.json"; // Using new file
import InteractiveCitySelector from "./InteractiveCitySelector";
import "./HolidayFlightPackage.css";

// --- UTILITY FUNCTIONS ---
const getCleanCityName = (airport) => airport?.cityName ? airport.cityName.split(',')[0] : '';

const addDays = (dateStr, days) => {
    if(!dateStr) return '';
    const result = new Date(dateStr);
    result.setDate(result.getDate() + parseInt(days));
    return result.toISOString().split('T')[0];
};

const formatDate = (dateInput, format = 'full') => {
    if(!dateInput) return '';
    const d = new Date(dateInput);
    if (isNaN(d.getTime())) return '';
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    const shortYear = String(year).slice(-2);
    const monthShort = d.toLocaleDateString('en-GB', { month: 'short' });

    switch(format) {
        case 'numeric': return `${day}-${month}-${shortYear}`;
        case 'short': return `${d.getDate()} ${monthShort}`;
        case 'full': 
        default: return `${day}-${month}-${year}`;
    }
};

const defaultStartDate = new Date(Date.now() + 86400000).toISOString().split('T')[0];

const HolidayFlightPackage = () => {
    const { user, loading } = useAuth();
    const navigate = useNavigate();
    const passengerRef = useRef(null);

    // --- STATE ---
    const [origin, setOrigin] = useState({ airport: null, query: '', date: defaultStartDate });
    const [returnDest, setReturnDest] = useState({ airport: null, query: '' });
    
    const [destinations, setDestinations] = useState([
        { id: Date.now(), airport: null, query: '', nights: 3, selectedCities: [] }
    ]);

    const [formData, setFormData] = useState({
        adults: 2, children: 0, infants: 0, 
        numRooms: 1, 
        hotelCategory: '5',
        mealType: 'MAP', 
        cabinClass: 'ECONOMY',
    });

    const [activeSearch, setActiveSearch] = useState(null); 
    const [searchResults, setSearchResults] = useState([]);
    const [isPassengerDropdownOpen, setPassengerDropdownOpen] = useState(false);
    const [showAdvancedOptions, setShowAdvancedOptions] = useState(false);
    
    const [showSummaryModal, setShowSummaryModal] = useState(false);
    const [isGenerating, setIsGenerating] = useState(false);
    const [activeModalDestIndex, setActiveModalDestIndex] = useState(null); 

    useEffect(() => { if (!loading && !user) navigate("/"); }, [user, loading, navigate]);
    
    // --- DERIVED STATE ---
    const totalNights = useMemo(() => {
        return destinations.reduce((acc, dest) => acc + dest.nights, 0);
    }, [destinations]);

    const returnDate = useMemo(() => {
        return addDays(origin.date, totalNights);
    }, [origin.date, totalNights]);

    // --- HANDLERS ---
    const handleSearch = (value, type, index = null) => {
        if (type === 'origin') setOrigin(prev => ({ ...prev, query: value, airport: value === '' ? null : prev.airport }));
        else if (type === 'return') setReturnDest(prev => ({ ...prev, query: value, airport: value === '' ? null : prev.airport }));
        else {
            const newDest = [...destinations];
            newDest[index].query = value;
            if (value === '') { 
                newDest[index].airport = null; 
                newDest[index].selectedCities = []; 
            }
            setDestinations(newDest);
        }

        if (value.length > 1) {
            const lowerValue = value.toLowerCase();
            const filtered = airports.filter(airport =>
                airport.cityName.toLowerCase().includes(lowerValue) || 
                airport.airportCode.toLowerCase().includes(lowerValue)
            ).slice(0, 7);
            setSearchResults(filtered);
            setActiveSearch(type === 'origin' ? 'origin' : type === 'return' ? 'return' : index);
        } else {
            setSearchResults([]);
            setActiveSearch(null);
        }
    };

    const handleSelect = (airport, type, index = null) => {
        const cleanName = `${getCleanCityName(airport)} (${airport.airportCode})`;
        const cityNameOnly = getCleanCityName(airport);
        
        if (type === 'origin') {
            setOrigin(prev => ({ ...prev, airport: airport, query: cleanName }));
            if (!returnDest.airport) setReturnDest({ airport: airport, query: cleanName });
        } else if (type === 'return') {
            setReturnDest({ airport: airport, query: cleanName });
        } else {
            const newDest = [...destinations];
            const prevCountry = newDest[index].airport?.countryName;
            
            newDest[index].airport = airport;
            newDest[index].query = cleanName;
            
            // Check if country changed to reset selected cities
            if (prevCountry !== airport.countryName) {
                newDest[index].selectedCities = [];
            }
            
            const cityExists = newDest[index].selectedCities.some(c => c.name === cityNameOnly);
            if (!cityExists) {
                newDest[index].selectedCities.push({ 
                    name: cityNameOnly, 
                    nights: newDest[index].nights, 
                    country: airport.countryName 
                });
            }
            setDestinations(newDest);
        }
        setSearchResults([]);
        setActiveSearch(null);
    };

    // --- DURATION HANDLERS ---
    const handleTotalDurationChange = (delta) => {
        const newDest = [...destinations];
        const currentFirstNights = newDest[0].nights;
        if (currentFirstNights + delta >= 1) {
            newDest[0].nights += delta;
            if (newDest[0].selectedCities.length === 1) {
                newDest[0].selectedCities[0].nights += delta;
            }
            setDestinations(newDest);
        }
    };

    const handleDestNightsChange = (index, delta) => {
        const newDest = [...destinations];
        const newVal = Math.max(1, newDest[index].nights + delta);
        newDest[index].nights = newVal;
        if (newDest[index].selectedCities.length === 1) {
            newDest[index].selectedCities[0].nights = newVal;
        }
        setDestinations(newDest);
    };

    const addDestinationBlock = () => {
        setDestinations([...destinations, { id: Date.now(), airport: null, query: '', nights: 3, selectedCities: [] }]);
    };

    const removeDestinationBlock = (index) => {
        if (destinations.length > 1) {
            setDestinations(destinations.filter((_, i) => i !== index));
        }
    };

    const handleAddCity = (destIndex, cityName) => {
        const newDest = [...destinations];
        if (!newDest[destIndex].selectedCities.some(c => c.name === cityName)) {
            newDest[destIndex].selectedCities.push({ name: cityName, nights: 1, country: newDest[destIndex].airport.countryName });
            setDestinations(newDest);
        }
    };

    const handleRemoveCity = (destIndex, cityName) => {
        const newDest = [...destinations];
        newDest[destIndex].selectedCities = newDest[destIndex].selectedCities.filter(c => c.name !== cityName);
        setDestinations(newDest);
    };

    const handleCityNightsChange = (destIndex, cityName, delta) => {
        const newDest = [...destinations];
        const cityIdx = newDest[destIndex].selectedCities.findIndex(c => c.name === cityName);
        if (cityIdx > -1) {
            const newNights = newDest[destIndex].selectedCities[cityIdx].nights + delta;
            if (newNights > 0) {
                newDest[destIndex].selectedCities[cityIdx].nights = newNights;
                setDestinations(newDest);
            }
        }
    };

    const handleCityReorder = (destIndex, newCityOrder) => {
        const newDest = [...destinations];
        newDest[destIndex].selectedCities = newCityOrder;
        setDestinations(newDest);
    };

    const handlePassengerChange = (type, delta) => {
        setFormData(prev => {
            const val = prev[type] + delta;
            if (val < 0 || (type === 'adults' && val < 1)) return prev;
            return { ...prev, [type]: val };
        });
    };

    const handleReviewClick = () => {
        if(!origin.airport) { alert("Please select a valid 'Fly From' origin city."); return; }
        const invalidDest = destinations.find(d => !d.airport);
        if(invalidDest) { alert("Please select a city for all Destination blocks."); return; }
        setShowSummaryModal(true);
    };

    const handleConfirmGenerate = async () => {
        setIsGenerating(true);
        const flights = [];
        let currentDate = origin.date;
        let previousAirport = origin.airport;
        let hotels = [];

        destinations.forEach(dest => {
            flights.push({ 
                departure: previousAirport.airportCode, 
                arrival: dest.airport.airportCode, 
                departureDate: currentDate 
            });

            let cityRunningDate = currentDate;
            dest.selectedCities.forEach(city => {
                const searchCity = city.name.trim().toLowerCase();
                const searchCountry = dest.airport.countryName.trim().toLowerCase();
                const matchedHotelCity = hotelCities.find(h => 
                    h.cityName.toLowerCase() === searchCity && 
                    h.countryName.toLowerCase() === searchCountry
                );

                const finalCityCode = matchedHotelCity ? String(matchedHotelCity.id) : city.name.substring(0, 3).toUpperCase();
                const finalCountryCode = dest.airport.countryCode || 'XX';

                hotels.push({
                    name: city.name, 
                    nights: city.nights, 
                    country: city.country, 
                    checkInDate: cityRunningDate,
                    cityCode: finalCityCode,
                    countryCode: finalCountryCode 
                });
                cityRunningDate = addDays(cityRunningDate, city.nights);
            });
            currentDate = addDays(currentDate, dest.nights);
            previousAirport = dest.airport;
        });

        flights.push({ 
            departure: previousAirport.airportCode, 
            arrival: returnDest.airport?.airportCode || origin.airport.airportCode, 
            departureDate: currentDate 
        });

        const originCode = origin.airport?.airportCode || 'ORG';
        const destCodes = destinations.map(d => d.airport?.airportCode || 'DST').join('-');
        const cleanStartDate = origin.date.replace(/-/g, '');
        const cleanEndDate = returnDate.replace(/-/g, '');
        const holidayKey = `${originCode}-${destCodes}-${cleanStartDate}-${cleanEndDate}-${totalNights}N`.toUpperCase();

        const payload = {
            holidayKey: holidayKey, 
            holidayType: "Flight", 
            journeyType: destinations.length > 1 ? "MultiCity" : "RoundTrip",
            flights, 
            hotels, 
            numberOfPeople: formData.adults + formData.children + formData.infants,
            numberOfNights: totalNights, 
            hotelCategory: formData.hotelCategory, 
            ...formData, 
            userId: user?.id,
            createdBy: user?.companyType
        };

        try {
            console.log("Generating holiday with payload:", payload);
            const response = await apiService.create(config.CREATEHOLIDAY, payload);
            setShowSummaryModal(false);
            const newHolidayId = response.holidayId || response.data?.holidayId || response.data?.data?.holidayId;
            if (newHolidayId) {
                navigate(`/holiday/${newHolidayId}`, { state: { activeTab: 9 } }); 
            } else {
                navigate("/dashboard");
            }
        } catch (error) {
            console.error("Error generating holiday:", error);
            alert("Failed to generate holiday.");
        } finally {
            setIsGenerating(false);
        }
    };

    let timelineDate = origin.date;
    let cardRunningDate = origin.date;

    return (
        <div id="layout-wrapper">
            <Header User={user} />
            <div className="main-content" style={{ marginTop: '5px' }}>
                <div className="page-content">
                    <div className="container-fluid">
                        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
                            <div className="hfp-wrapper">
                                {/* 1. TOP BAR */}
                                <div className="hfp-top-bar origin-theme">
                                    <div className="hfp-input-group hfp-col-origin hfp-search-container">
                                        <label className="hfp-label-mini text-indigo"><RiFlightTakeoffLine/> Fly From</label>
                                        <input type="text" className="hfp-input-compact border-indigo" placeholder="Hyderabad (HYD)" value={origin.query} onChange={(e) => handleSearch(e.target.value, 'origin')} />
                                        {activeSearch === 'origin' && searchResults.length > 0 && (
                                            <div className="hfp-dropdown-results">
                                                {searchResults.map(apt => (
                                                    <div key={apt.airportCode} className="hfp-result-item" onClick={() => handleSelect(apt, 'origin')}>
                                                        <strong>{getCleanCityName(apt)} ({apt.airportCode})</strong>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                    <div className="hfp-input-group" style={{width: '180px'}}>
                                        <label className="hfp-label-mini"><RiCalendarLine/> Start Date</label>
                                        <input type="date" className="hfp-input-compact" value={origin.date} onChange={(e) => setOrigin({...origin, date: e.target.value})} min={defaultStartDate} />
                                    </div>
                                    <div className="hfp-input-group text-center" style={{width: '130px'}}>
                                        <label className="hfp-label-mini">Total Duration</label>
                                        <div className="hfp-counter-compact">
                                            <button onClick={() => handleTotalDurationChange(-1)}><RiSubtractLine /></button>
                                            <span style={{ minWidth: '35px', textAlign: 'center' }}>{totalNights} N</span>
                                            <button onClick={() => handleTotalDurationChange(1)}><RiAddLine /></button>
                                        </div>
                                    </div>
                                    <div className="hfp-input-group" style={{position: 'relative', width: '250px'}} ref={passengerRef}>
                                        <label className="hfp-label-mini"><RiUserLine/> Travelers</label>
                                        <button className="hfp-input-compact text-start" onClick={() => setPassengerDropdownOpen(!isPassengerDropdownOpen)}>
                                            {formData.adults} Adult, {formData.children} Kids, {formData.infants} Inf
                                        </button>
                                        {isPassengerDropdownOpen && (
                                            <div className="hfp-passenger-dropdown">
                                                {['Adults', 'Children', 'Infants'].map(type => (
                                                    <div key={type} className="hfp-p-row">
                                                        <span className="hfp-p-label">{type}</span>
                                                        <div className="hfp-p-ctrl">
                                                            <button onClick={() => handlePassengerChange(`${type.toLowerCase()}`, -1)}><RiSubtractLine/></button>
                                                            <span>{formData[`${type.toLowerCase()}`]}</span>
                                                            <button onClick={() => handlePassengerChange(`${type.toLowerCase()}`, 1)}><RiAddLine/></button>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                    <div className="hfp-input-group" style={{width: '150px'}}>
                                        <label className="hfp-label-mini"><RiCalendarLine/> Return Date</label>
                                        <input type="text" className="hfp-input-compact" value={formatDate(returnDate, 'full')} readOnly style={{backgroundColor: '#f9fafb', cursor: 'default', color: '#666'}} />
                                    </div>
                                </div>

                                {/* 2. DESTINATIONS */}
                                <div className="hfp-middle-section">
                                    <div className="hfp-scroll-container">
                                        {destinations.map((dest, index) => {
                                            const currentBlockStartDate = cardRunningDate;
                                            cardRunningDate = addDays(cardRunningDate, dest.nights);
                                            let cityRunner = currentBlockStartDate;
                                            return (
                                                <div key={dest.id} className="hfp-dest-card">
                                                    <div className="hfp-dest-header-colored">
                                                        <span className="hfp-dh-title"><RiMapPinLine className="me-1"/> {dest.airport ? dest.airport.countryName : `Destination ${index + 1}`}</span>
                                                        <button className="hfp-dh-delete" onClick={() => removeDestinationBlock(index)} disabled={destinations.length===1}><RiDeleteBinLine/></button>
                                                    </div>
                                                    <div className="hfp-dest-body">
                                                        <div className="d-flex gap-2 align-items-end mb-2">
                                                            <div className="flex-grow hfp-search-container">
                                                                <label className="hfp-label-mini">Select City</label>
                                                                <input type="text" className="hfp-input-compact" placeholder="Search Destination..." value={dest.query} onChange={(e) => handleSearch(e.target.value, 'dest', index)} />
                                                                {activeSearch === index && searchResults.length > 0 && (
                                                                    <div className="hfp-dropdown-results">
                                                                        {searchResults.map(apt => (
                                                                            <div key={apt.airportCode} className="hfp-result-item" onClick={() => handleSelect(apt, 'dest', index)}>
                                                                                <strong>{getCleanCityName(apt)} ({apt.airportCode})</strong>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                )}
                                                            </div>
                                                            <div style={{width: '80px'}}>
                                                                <label className="hfp-label-mini">Nights</label>
                                                                <div className="hfp-counter-compact">
                                                                    <button onClick={() => handleDestNightsChange(index, -1)}>-</button>
                                                                    <span>{dest.nights}</span>
                                                                    <button onClick={() => handleDestNightsChange(index, 1)}>+</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {dest.airport && (
                                                            <div className="hfp-card-places">
                                                                <div className="d-flex justify-content-between align-items-center mb-2">
                                                                    <span className="small fw-bold text-indigo">Stays</span>
                                                                    <button className="hfp-btn-text" onClick={() => setActiveModalDestIndex(index)}><RiAddLine/> Add/Edit Places</button>
                                                                </div>
                                                                <div className="hfp-places-list">
                                                                    {dest.selectedCities.map((city, cIdx) => {
                                                                        const displayDate = cityRunner;
                                                                        cityRunner = addDays(cityRunner, city.nights);
                                                                        return (
                                                                            <div key={cIdx} className="hfp-place-chip">
                                                                                <span className="chip-name">{city.name}</span>
                                                                                <div style={{display:'flex', alignItems:'center', gap:'8px'}}>
                                                                                    <span className="chip-badge"><RiHotelBedLine/> {city.nights}N Hotel Stay</span>
                                                                                    <span style={{color:'#cbd5e1'}}>|</span>
                                                                                    <span className="chip-date text-indigo fw-bold">{formatDate(displayDate, 'short')}</span>
                                                                                </div>
                                                                            </div>
                                                                        );
                                                                    })}
                                                                    {dest.selectedCities.length === 0 && <div className="text-center text-muted small fst-italic py-2">No places added</div>}
                                                                </div>
                                                            </div>
                                                        )}
                                                        {!dest.airport && <div className="hfp-empty-placeholder">Select a destination above</div>}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                        <button className="hfp-add-dest-card" onClick={addDestinationBlock}>
                                            <div className="icon-circle"><RiAddLine /></div>
                                            <span>Add Destination</span>
                                        </button>
                                    </div>
                                </div>

                                <div className="hfp-footer-compact">
                                    <button className="hfp-toggle-advanced" onClick={() => setShowAdvancedOptions(!showAdvancedOptions)}>
                                        {showAdvancedOptions ? 'Hide Advanced Options' : 'Show Advanced Options'}
                                    </button>
                                    <button className="hfp-btn-generate" onClick={handleReviewClick}>
                                        <RiMagicLine className="me-2" /> Review & Generate
                                    </button>
                                </div>
                                
                                {showAdvancedOptions && (
                                    <div className="hfp-advanced-panel">
                                         <div className="d-flex gap-3">
                                            <div className="flex-grow">
                                                <label className="hfp-label-mini">Class</label>
                                                <select className="hfp-input-compact" value={formData.cabinClass} onChange={(e)=>setFormData({...formData, cabinClass: e.target.value})}>
                                                    <option value="ECONOMY">Economy</option>
                                                    <option value="BUSINESS">Business</option>
                                                </select>
                                            </div>
                                            <div className="flex-grow">
                                                <label className="hfp-label-mini">Hotel Category</label>
                                                <select className="hfp-input-compact" value={formData.hotelCategory} onChange={(e)=>setFormData({...formData, hotelCategory: e.target.value})}>
                                                    <option value="3">3 Star</option>
                                                    <option value="4">4 Star</option>
                                                    <option value="5">5 Star</option>
                                                </select>
                                            </div>
                                            <div className="flex-grow">
                                                <label className="hfp-label-mini">Meal</label>
                                                <select className="hfp-input-compact" value={formData.mealType} onChange={(e)=>setFormData({...formData, mealType: e.target.value})}>
                                                    <option value="CP">Breakfast</option>
                                                    <option value="MAP">Breakfast & Dinner</option>
                                                </select>
                                            </div>
                                            <div className="flex-grow">
                                                <label className="hfp-label-mini">Rooms</label>
                                                <input type="number" className="hfp-input-compact" value={formData.numRooms} onChange={(e)=>setFormData({...formData, numRooms: parseInt(e.target.value) || 1})} min="1"/>
                                            </div>
                                         </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Modals */}
                        {activeModalDestIndex !== null && (
                            <div className="hfp-modal-overlay">
                                <div className="hfp-modal-container">
                                    <div className="hfp-modal-header">
                                        <h3 className="hfp-modal-title">Select Places in {destinations[activeModalDestIndex].airport.countryName}</h3>
                                        <button className="hfp-modal-close" onClick={() => setActiveModalDestIndex(null)}><RiCloseLine/></button>
                                    </div>
                                    <div className="hfp-modal-body">
                                        <InteractiveCitySelector 
                                            country={destinations[activeModalDestIndex].airport.countryName}
                                            cities={destinations[activeModalDestIndex].selectedCities}
                                            maxNights={destinations[activeModalDestIndex].nights} 
                                            startDate={origin.date} 
                                            onAddCity={(name) => handleAddCity(activeModalDestIndex, name)}
                                            onRemoveCity={(name) => handleRemoveCity(activeModalDestIndex, name)}
                                            onNightsChange={(name, delta) => handleCityNightsChange(activeModalDestIndex, name, delta)}
                                            onReorder={(newOrder) => handleCityReorder(activeModalDestIndex, newOrder)}
                                        />
                                    </div>
                                    <div className="hfp-modal-footer"><button className="hfp-btn-primary" onClick={() => setActiveModalDestIndex(null)}>Done</button></div>
                                </div>
                            </div>
                        )}

                        {showSummaryModal && (
                            <div className="hfp-modal-overlay">
                                <div className="hfp-modal-container" style={{maxWidth: '800px', borderRadius: '16px'}}>
                                    <div className="hfp-modal-header border-0 pb-0">
                                        <h3 className="hfp-modal-title"><RiCheckLine className="text-primary me-2"/> Review Your Itinerary</h3>
                                        <button className="hfp-modal-close" onClick={() => setShowSummaryModal(false)}><RiCloseLine/></button>
                                    </div>
                                    <div className="hfp-modal-body pt-2" style={{background: '#fff'}}>
                                        <div className="hfp-section-title">TRAVELERS & PREFERENCES</div>
                                        <div className="hfp-pref-grid">
                                            <div className="hfp-pref-card"><div className="lbl"><RiUserLine/> Travelers</div><div className="val">{formData.adults} Adults, {formData.children} Kids</div></div>
                                            <div className="hfp-pref-card"><div className="lbl"><RiHotelBedLine/> Hotel</div><div className="val">{formData.hotelCategory} Star | {formData.numRooms} Room(s)</div></div>
                                            <div className="hfp-pref-card"><div className="lbl"><RiRestaurantLine/> Meal Plan</div><div className="val">{formData.mealType}</div></div>
                                            <div className="hfp-pref-card"><div className="lbl"><RiArmchairLine/> Cabin</div><div className="val">{formData.cabinClass}</div></div>
                                        </div>
                                        <div className="hfp-section-title mt-4">FLIGHT & STAY TIMELINE</div>
                                        <div className="hfp-timeline-container">
                                            {destinations.map((dest, i) => {
                                                const flightDate = timelineDate;
                                                const fromCode = i === 0 ? origin.airport?.airportCode || 'ORG' : destinations[i-1].airport?.airportCode || 'PRV';
                                                const toCode = dest.airport?.airportCode || 'DST';
                                                let stayTimeline = timelineDate; 
                                                timelineDate = addDays(timelineDate, dest.nights);
                                                return (
                                                    <div key={i} className="hfp-timeline-card">
                                                        <div className="hfp-timeline-header">
                                                            <div className="route"><span className="code">{fromCode}</span><RiPlaneLine className="icon-plane" /><span className="code">{toCode}</span></div>
                                                            <div className="date-badge"><RiCalendarLine/> {formatDate(flightDate, 'full')}</div>
                                                        </div>
                                                        <div className="hfp-timeline-stays">
                                                            {dest.selectedCities.length > 0 ? (
                                                                dest.selectedCities.map((city, cIdx) => {
                                                                    const checkInDate = stayTimeline;
                                                                    const checkOutDate = addDays(stayTimeline, city.nights);
                                                                    stayTimeline = checkOutDate;
                                                                    return (
                                                                        <div key={cIdx} className="hfp-stay-chip">
                                                                            <RiHotelBedLine className="icon" />
                                                                            <span className="city">{city.name} ({city.nights}N)</span>
                                                                            <span className="date">{formatDate(checkInDate, 'numeric')} to {formatDate(checkOutDate, 'numeric')}</span>
                                                                        </div>
                                                                    );
                                                                })
                                                            ) : (<span className="text-muted small">No specific stays added</span>)}
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                            <div className="hfp-timeline-card return">
                                                <div className="hfp-timeline-header">
                                                    <div className="route"><span className="code">{destinations[destinations.length-1].airport?.airportCode || 'LST'}</span><RiPlaneLine className="icon-plane" /><span className="code">{returnDest.airport?.airportCode || origin.airport?.airportCode || 'ORG'}</span></div>
                                                    <div className="date-badge"><RiCalendarLine/> Return Flight • {formatDate(returnDate, 'full')}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="hfp-modal-footer pt-3 pb-3" style={{justifyContent: 'flex-end', gap: '10px'}}>
                                        <button className="hfp-btn-outline" onClick={() => setShowSummaryModal(false)}>Edit</button>
                                        <button className="hfp-btn-generate" onClick={handleConfirmGenerate} disabled={isGenerating}>
                                            {isGenerating ? (<><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>Generating...</>) : 'Confirm & Generate'}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HolidayFlightPackage;